<div class="contact-page-wrapper">
    <div class="contact-card">
        <h2 class="panel-title">Get in touch</h2>
        <p class="panel-subtitle">
            We'd love to hear from you. For any inquiries, support, or feedback, please reach out directly via email.
        </p>

        <div class="contact-details">
            <div class="detail-item">
                <mat-icon>email</mat-icon>
                <div class="text">
                    <span class="label">Email Us</span>
                    <a href="mailto:solutions@ksolve.com" class="value link">solutions&#64;ksolve.com</a>
                </div>
            </div>
        </div>
    </div>
</div>